import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {roles} from "../../../../shared/constants/common.constants";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DropdownOption} from "../../../../../models/dropdown-option.model";
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {
  EditProfileByUserIdRequest,
  FetchStatusFilterRequest, UpdateUserStatusRequest
} from '../../core/manage-users.actions';
import {
  editUserStatusInfo,
  statusFilter, updateUserStatusLoading
} from '../../core/manage-users.selectors';
import {CommonService} from "../../../../shared/services/common.service";

@Component({
  selector: 'app-change-user-status',
  templateUrl: './change-user-status.component.html',
  styleUrls: ['./change-user-status.component.css']
})
export class ChangeUserStatusComponent implements OnInit, OnDestroy {
  @Input() data: { userData: any; }

  user: string;
  role: string;
  currentUserStatus: string;
  userStatusDropdownOptions: DropdownOption[] = [];
  userStatusLoading: boolean = false;
  form = new FormGroup({
    userStatus: new FormControl({value: null, disabled: false}, {
      validators: [
        Validators.required
      ]
    })
  });
  errorMessages: any = {};
  errorMessageMap = {
    userStatus: {
      required: "This field is required."
    },
  };
  editUserStatusLoading: boolean = false;
  protected readonly roles = roles;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
    this.store.dispatch(FetchStatusFilterRequest());
  }

  ngOnInit() {
    this.currentUserStatus = this.data?.userData?.status?.value;
    this.user = `${this.data?.userData?.firstName} ${this.data?.userData?.lastName}`;
    this.role = this.data?.userData?.role?.value;

    this.store
      .select((statusFilter))
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data: any) => {
        this.userStatusLoading = data?.loading;
        this.userStatusDropdownOptions = data?.list.filter(eachStatus => {
          return eachStatus.key > 1 && eachStatus.key !== this.data?.userData?.status.key
        });
      });

    this.store
      .select(updateUserStatusLoading)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.editUserStatusLoading = data
      })
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  save() {
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    const {
      userStatus,
    } = this.form.getRawValue();


    const payload = {
      status: userStatus,
      forUserId: this.data?.userData?.userId
    };
    // Dispatch Action
    this.store.dispatch(UpdateUserStatusRequest({payload}));
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
